
import { Vue, Component } from 'vue-property-decorator'

@Component({
  name: 'AvatarBasic'
})
export default class AvatarBasic extends Vue {}
